import { render, staticRenderFns } from "./ExpressPoshtaReportTable.vue?vue&type=template&id=2f16d240&scoped=true"
import script from "./ExpressPoshtaReportTable.vue?vue&type=script&lang=js"
export * from "./ExpressPoshtaReportTable.vue?vue&type=script&lang=js"
import style0 from "./ExpressPoshtaReportTable.vue?vue&type=style&index=0&id=2f16d240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16d240",
  null
  
)

export default component.exports